import axios from 'axios';

const whitelistAxios = axios.create({
  baseURL: 'http://109.123.235.145:8080',
  withCredentials: true
});

export default whitelistAxios;
